<div class="mmao__history" *ngIf="negotiation.events">
  <div class="mmao__history__title" i18n="@@MMAO.POPIN.OTHER_MSG.HISTORY">History</div>
  <div *ngFor="let event of negotiation.events">
    <div *ngIf="event.userMessage" class="mmao__history__entry">
      <vc-images
        class="mmao__history__entry__userPicture"
        [width]="40"
        [height]="40"
        url="{{ getRequester(event).picture.path }}"
        alt="profil-{{ getRequester(event).firstname }}"
      ></vc-images>
      <div class="mmao__history__entry__userInfos">
        <div class="mmao__history__entry__title">{{ event.userMessage }}</div>
        <div class="mmao__history__entry__date">
          {{ getRequester(event).firstname }} • {{ event.creationDate | date: 'medium' }}
        </div>
      </div>
      <div class="mmao__history__amount">{{ event.price.formatted }}</div>
    </div>
  </div>
</div>
